import { observer } from 'mobx-react-lite'
import { type ReactNode } from 'react'
import { Box, Icon, SpinnerLoader, Typography } from 'shared/ui'
import type { IDropdownItem } from 'shared/ui/Dropdown'
import styles from './styles.module.scss'

type ISelectConnectionTriggerProps = {
  isLoading: boolean
  isValueSelected: boolean
  placeholder: string
  triggerContent?: ReactNode
  selectedItem?: IDropdownItem | null
}
export const SelectValueTrigger = observer(
  ({
    isLoading,
    isValueSelected,
    placeholder,
    triggerContent,
    selectedItem,
  }: ISelectConnectionTriggerProps) => {
    const content = () => {
      if (isLoading) {
        return (
          <div className={styles.loaderTrigger}>
            <SpinnerLoader ariaLabel={'SelectValueTrigger'} size={12} />
          </div>
        )
      }

      if (!isValueSelected) {
        return (
          <Typography
            ariaLabel='Empty value'
            variant={'text-input-field-r'}
            color='var(--content-primary-disabled)'
          >
            {placeholder}
          </Typography>
        )
      }
      return (
        triggerContent || (
          <Box display={'flex'} alignItems={'center'} gap={1}>
            {selectedItem?.iconL && <Icon icon={selectedItem.iconL} fontSize={16} />}
            <Typography variant={'text-input-field-r'} ariaLabel={'SelectedIntegration'}>
              {selectedItem?.label}
            </Typography>
          </Box>
        )
      )
    }

    return <div>{content()}</div>
  }
)
